import React, { useState } from "react";
import "./FinanceAddOrUpdatePopup.css";

interface Props {
  handleClose: any;
  handleConfirmation: any;
  item?: any;
}

const CATEGORIES = ["Potraviny a pití", "Dům", "Garáž", "Osobní", "Crit", "Auto", "Zábava", "Léky", "Oblečení", "Zdraví"];

const toDateInputValue = (value: any) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const FinanceAddOrUpdatePopup = (props: Props) => {
  const isDefinition = !!(props.item && props.item.expensesAndIncomesDefinitionId);
  const isEdit =
    !!(props.item &&
      (props.item.expensesAndIncomesId ||
        props.item.expensesAndIncomesDefinitionId));

  const [formData, setFormData] = useState({
    expensesAndIncomesId: props.item?.expensesAndIncomesId ?? 0,
    expensesAndIncomesDefinitionId:
      props.item?.expensesAndIncomesDefinitionId ?? 0,
    isIncome: props.item?.isIncome ?? false,
    amount: props.item?.amount ?? 0,
    category: props.item?.category ?? "Potraviny a pití",
    location: props.item?.location ?? "",
    description: props.item?.description ?? "",
    isRepeatable: props.item?.isRepeatable ?? isDefinition,
    frequencyInDays: props.item?.frequencyInDays ?? 30,
    dueDate: isDefinition
      ? toDateInputValue(props.item?.created)
      : toDateInputValue(new Date()),
    date: toDateInputValue(props.item?.created ?? new Date()),
  });

  return (
    <div className="financePopupRoot">
      <div className="financeOverlay" onClick={props.handleClose}></div>

      <div className="financeModal">
        <div className="financeModal__header">
          <div className="financeModal__title">
            <i className="fas fa-wallet"></i>
            {isEdit ? "Úprava položky" : "Přidání nové položky"}
          </div>
          <button
            className="financeModal__close"
            onClick={props.handleClose}
            type="button"
            aria-label="Zavřít"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="financeModal__body">
          {/* Income / Expense toggle */}
          <div className="financeToggle">
            <button
              type="button"
              className={
                "financeToggle__btn expense" +
                (!formData.isIncome ? " active" : "")
              }
              onClick={() => setFormData({ ...formData, isIncome: false })}
            >
              <i className="fas fa-arrow-down"></i> Výdej
            </button>
            <button
              type="button"
              className={
                "financeToggle__btn income" +
                (formData.isIncome ? " active" : "")
              }
              onClick={() => setFormData({ ...formData, isIncome: true })}
            >
              <i className="fas fa-arrow-up"></i> Příjem
            </button>
          </div>

          <div className="financeField">
            <label htmlFor="amount">Částka</label>
            <div className="financeAmount">
              <input
                type="number"
                id="amount"
                value={formData.amount}
                onChange={(event) => {
                  setFormData({
                    ...formData,
                    amount: event.target.valueAsNumber || 0,
                  });
                }}
              />
              <span className="financeAmount__currency">Kč</span>
            </div>
          </div>

          {!formData.isRepeatable && (
            <div className="financeField">
              <label htmlFor="date">Datum</label>
              <input
                type="date"
                id="date"
                value={formData.date}
                onChange={(event) => {
                  setFormData({ ...formData, date: event.target.value });
                }}
              />
            </div>
          )}

          <div className="financeField">
            <label htmlFor="category">Kategorie</label>
            <select
              id="category"
              value={formData.category}
              onChange={(event) => {
                setFormData({ ...formData, category: event.target.value });
              }}
            >
              {CATEGORIES.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          <div className="financeField">
            <label htmlFor="location">Místo</label>
            <input
              type="text"
              id="location"
              value={formData.location}
              placeholder="Např. Kaufland, Benzínka..."
              onChange={(event) => {
                setFormData({ ...formData, location: event.target.value });
              }}
            />
          </div>

          <div className="financeField">
            <label htmlFor="description">Popis</label>
            <textarea
              id="description"
              value={formData.description}
              rows={3}
              onChange={(event) => {
                setFormData({ ...formData, description: event.target.value });
              }}
            />
          </div>

          {/* Recurring payment */}
          <div className="financeRecurring">
            <label className="financeSwitch">
              <input
                type="checkbox"
                checked={formData.isRepeatable}
                onChange={(event) => {
                  setFormData({
                    ...formData,
                    isRepeatable: event.target.checked,
                  });
                }}
              />
              <span className="financeSwitch__slider"></span>
              <span className="financeSwitch__label">
                <i className="fas fa-sync-alt"></i> Rekurentní platba
              </span>
            </label>

            {formData.isRepeatable && (
              <div className="financeRecurring__fields">
                <div className="financeField">
                  <label htmlFor="dueDate">Datum splatnosti</label>
                  <input
                    type="date"
                    id="dueDate"
                    value={formData.dueDate}
                    onChange={(event) => {
                      setFormData({ ...formData, dueDate: event.target.value });
                    }}
                  />
                </div>
                <div className="financeField">
                  <label htmlFor="frequencyInDays">Opakování (dny)</label>
                  <input
                    type="number"
                    id="frequencyInDays"
                    min={1}
                    value={formData.frequencyInDays}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        frequencyInDays: event.target.valueAsNumber || 0,
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="financeModal__footer">
          <button
            type="button"
            className="financeBtn financeBtn--ghost"
            onClick={props.handleClose}
          >
            Storno
          </button>
          <button
            type="button"
            className="financeBtn financeBtn--primary"
            onClick={() => {
              props.handleConfirmation(formData);
            }}
          >
            <i className="fas fa-check"></i>
            {isEdit ? "Uložit" : "Přidat"}
          </button>
        </div>
      </div>
    </div>
  );
};
